import { useAtom } from "jotai";
import { rendimientoAtom } from "../store/store";
import { RendimientoService } from "services/comunicacion-cultura";

const useRendimientoPage = () => {

    const [rendimiento, setRendimiento] = useAtom(rendimientoAtom);

    const fetchRendimiento = async () => {
        const data = await RendimientoService.listar();
        setRendimiento(data);
    };

    return {
        rendimiento,
        fetchRendimiento,
    };
};

export default useRendimientoPage;
